import React, {FC, useMemo} from "react";
import {useGetEmailNotificationsByBookingIdQuery} from "../../../generated/graphql";
import {getInvoiceSentStatus, InvoiceForStatus} from "./getInvoiceSentStatus";
import InvoiceSentStatusTag from "./InvoiceSentStatusTag";

type Props = {
    bookingId: string;
    invoice: InvoiceForStatus | null | undefined;
    isReversal?: boolean;
};

const InvoiceSentStatusTagContainer: FC<Props> = ({bookingId, invoice, isReversal}) => {
    // Apollo dedupliziert die Query gegenüber `CommunicationHistoryBooking`
    // (gleiche Operation + gleiche Variable) — kein doppelter Roundtrip.
    // Während `data === undefined` (erster Roundtrip) liefert der Helper
    // `NotSent`; sobald die Query resolved, springt der Tag auf den korrekten
    // Status. Kurzer Flicker akzeptabel; dauerhaft unsichtbar wäre schlimmer.
    const {data} = useGetEmailNotificationsByBookingIdQuery({
        variables: {bookingId},
        fetchPolicy: "cache-and-network",
    });

    const statusResult = useMemo(
        () => getInvoiceSentStatus(invoice, data?.notificationsByBooking, {isReversal}),
        [invoice, data?.notificationsByBooking, isReversal],
    );

    if (!invoice) {
        return null;
    }

    return <InvoiceSentStatusTag statusResult={statusResult} />;
};

export default InvoiceSentStatusTagContainer;
